import React from 'react';
import "./styles.sass";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import ReservationService from 'Services/reservation.service';
import waitlistmanagementService from 'Services/waitlistmanagement.service';
import { MvConfirmationModal } from 'Generic/MvConfirmationModal/MvConfirmationModal';
import MvLoader from 'Generic/MvLoader/MvLoader';
import BookingInfo from 'Components/Pages/ApplyYourPoints/BookingInfo';
import BookingInfoExists from 'Components/Pages/ApplyYourPoints/BookingInfoExists';
import StayPreferences from '../StayPreferences';
import GuestProfile from '../GuestProfile';
import { AdditionalGuestProfile } from '../AdditionalGuestProfile';
import { UsageDetails } from '../UsageDetails';
import { MvTermsConditions } from 'Generic/MvTermsConditions';
import MvLink from 'Generic/MvLink';
import { MvPrimaryBtn } from 'Generic/MvPrimaryBtn';
import { ScreenType } from 'Constants';
import { ContractUsage, Preferences, ReservationDetails, WaitlistAYPResult, WaitListReservationDetails, WaitlistRooms, WaitlistSummaryResponse } from 'Interfaces/AYPResultInterface';
import { BookResortParams, PrimaryGuest, Term } from 'Interfaces/BookResort';
import { GuestDetail, GuestEmail } from '../AdditionalGuestProfile/AdditionalGuestProfile';
import ContractToolTip from 'Interfaces/ContractToolTipInterface';
// @ts-ignore
import sessionStorage from 'store/storages/sessionStorage';
import { ReactAppMode } from 'Interfaces/ReactAppModes';
import {EXEC_MODE} from "../../../../cfg";
import WaitlistManagementService from 'Services/waitlistmanagement.service';
import { AffordableRoom, WaitlistBookResortParams, WaitlistCreateResultData, WaitlistPointUsage } from 'Interfaces/CreateWaitlist';
import WaitlistCriteria from '../WaitlistCriteria';
import { logAnalyticData, trackAnalyticData } from 'Utils/analytics';
import { getAlternateSearchValue } from 'Utils/AlternateSearchValue';

const md5 = require("md5");

// key is preference code
export type SelectedPreferenceOptions = {
    [key: string]: string|string[];
};

export interface SelectedPreferences {
    roomRequests: SelectedPreferenceOptions; // dynamic requests from back-end
    additionalRequests: string; // special requests text area
};

enum PageErrorType {
    'terms' = 'terms',
    'emails' = 'emails',
    'primaryGuest' = 'primaryGuest',
    'additionalGuests' = 'additionalGuests',
};

interface PageErrors {
    [PageErrorType.emails]: {
        message: string;
        isErrored: boolean;
    };
    [PageErrorType.additionalGuests]: {
        message: string;
        isErrored: boolean;
    };
    [PageErrorType.terms]: {
        message: string;
        isErrored: boolean;
    };
    [PageErrorType.primaryGuest]: {
        message: string;
        isErrored: boolean;
    };
};

interface Props {
    resId: number;
    waitListId?: number;
    setScreenType(screenType: ScreenType): void;
    appliedPointContracts: ContractUsage[]|null;
    contractToolTips: ContractToolTip[];
    handleContractsSort: (sortedContracts: ContractUsage[]) => void;
    screenType?: string;
    apiTimeout: string;
};

interface State {
    submissionPending: boolean;
    showCancelModal: boolean;
    loading: boolean;
    selectedPreferences: SelectedPreferences;
    reservationDetails: ReservationDetails;
    waitlistReservationDetails: WaitListReservationDetails;
    primaryGuest: PrimaryGuest;
    primaryGuestInfo: PrimaryGuest
    terms: Term[];
    preferenceOptions: Preferences;
    waitlistPreferences: Preferences; 
    additionalGuests: GuestDetail[];
    emails: GuestEmail[];
    pageErrors: PageErrors;
    isEditInProgress: boolean;
    showErrorModal: boolean;
    errorMessage: string;
    waitlistReservationId: string;
    sessionId: string;
    priority: number;
    expirationLeadTime: number | undefined,
    waitlistRooms: WaitlistRooms[];
    affordableRoom: AffordableRoom;
    isAlternateSearchAvailable: boolean;
    allTnCChecked: boolean;
};

const InitPageErrors: PageErrors = {
    [PageErrorType.emails]: {
        message: 'You have entered an invalid additional email address.',
        isErrored: false,
    },
    [PageErrorType.additionalGuests]: {
        message: 'Additional Guests must have both a first and last name.',
        isErrored: false,
    },
    [PageErrorType.terms]: {
        message: 'Must acknowledge Terms & Conditions.',
        isErrored: false,
    },
    [PageErrorType.primaryGuest]: {
        message: 'Must save or cancel Primary Guest changes.',
        isErrored: false,
    },
};

const InitState: State = {
    submissionPending: false,
    showCancelModal: false,
    loading: true,
    selectedPreferences: {
        roomRequests: {},
        additionalRequests: '',
    },
    reservationDetails: {
        resortName: "",
        resortLocation: "",
        resortImage: "",
        roomType:[],
        checkInDate: "",
        checkOutDate: "",
        numOfNights: 0,
        numOfGuests: 0,
        accessibility: [],
        hearingaccessible: false,
        pointsRequired: 0,
    },
    waitlistReservationDetails: {
        resortName: "",
        resortId: "",
        resortLocation: "",
        resortImage: "",
        roomType: [],
        checkInRangeStart: "",
        checkInRangeEnd: "",
        marshaRateCode: "",
        numOfNights: 0,
        numOfGuests: 0,
        accessibility: [],
        hearingaccessible: false,
        pointsRequired: 0,
        checkInSunday: true,
        checkInMonday: true,
        checkInTuesday: true,
        checkInWednesday: true,
        checkInThursday: true,
        checkInFriday: true,
        checkInSaturday: true
      },
    primaryGuestInfo: {
        bonvoyNumber: '',
        country: 0,
        countryDescription: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        state: 0,
        stateDescription: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        email: '',
    },
    primaryGuest: {
        bonvoyNumber: '',
        country: 0,
        countryDescription: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        state: 0,
        stateDescription: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        email: '',
    },
    terms: [],
    preferenceOptions: [],
    additionalGuests: [],
    emails: [],
    pageErrors: Object.assign({}, InitPageErrors),
    isEditInProgress: false,
    showErrorModal: false,
    errorMessage: '',
    sessionId: "",
    waitlistReservationId: "",
    priority: 0,
    expirationLeadTime: 0,
    waitlistRooms: [],
    affordableRoom: {
        roomPoolCode: "",
        rateCode: [],
        pointAmountMin: 0,
        pointAmountMax: 0
    },
    waitlistPreferences: [],
    isAlternateSearchAvailable: false,
    allTnCChecked: false,
}

class Review extends React.Component<Props, State> {
    reservationService: ReservationService;
    waitlistService: WaitlistManagementService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this.waitlistService = new WaitlistManagementService();
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({
      isAlternateSearchAvailable: getAlternateSearchValue(),
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        sessionStorage.remove("WAITLIST_RESPONSE");
    }

    componentWillReceiveProps(nProps: Props) {
        // if we didn't have the appliedPointContracts, but now we do, then now we're ready
        if (this.props.appliedPointContracts === null && Array.isArray(nProps.appliedPointContracts)) {
            this.fetchResInfo(nProps);
        }
    }

    fetchResInfo(props: Props) {
        // check if the user has borrowed points, we send that to API call
        const borrowedPoints = (props.appliedPointContracts || []).some(contract => {
            return contract.appliedPoints > 0 && contract.borrowChecked === true
        });
        if (props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW) {
            this.reservationService.getResWaitlistSummary(props.waitListId || 0)
            .then(res => {
                //get summary => reservationdetails, primary guest, terms
                //waitlistrooms
                // const { preferences, waitinglistDetails, reservationDetails, primaryGuest, terms, waitlistRooms } = res;
                const {summary, waitlistRooms} = res;

                //CE2RT1C-901: filter out duplicate terms with "-no-tags" in type node of terms
                const termsWithFilter: Term[] = summary.terms.filter((term: Term) => {
                    return !term.type.includes("-no-tags");
                }); 

                this.setState({
                    loading: false,
                    waitlistReservationDetails:  summary.reservationDetails,
                    waitlistRooms: waitlistRooms,
                    //The reservation Flow address field comes as an object is different from the waitlist structure
                    //The below change is to accomodate the new structure
                    // primaryGuest: {...primaryGuest, address:{...primaryGuest}},
                    primaryGuest: summary.primaryGuest,
                    //handing empty terms
                    terms: termsWithFilter,
                    //handling preference options since its not coming in the correct format
                    //preferenceOptions: [{ options: preferences.map((x: any) => ({ label: x.id, name: x.name })) } as any],
                    // selectedPreferences,
                })
            });
        } else {
        this.reservationService.getResBookingSummary(props.resId, borrowedPoints)
            .then(res => {
                const { preferences, reservationDetails, primaryGuest, terms } = res;

                // check for selected preferences in session
                let selectedPreferences = JSON.parse(sessionStorage.read(ReservationService.SELECTED_PREFERENCES));

                // if no selected preferences in session, set empty preferences with default selections
                if (!selectedPreferences) {
                    selectedPreferences = {...this.state.selectedPreferences};

                    (preferences as Preferences).map(preference => {
                        preference.options.map(option => {
                            if (option.default) {
                                selectedPreferences = {
                                    ...selectedPreferences,
                                    roomRequests: {
                                        ...selectedPreferences.roomRequests,
                                        [preference.code]: option.code,
                                    },
                                };
                            }
                        })
                    });
                }

                //CE2RT1C-901: filter out duplicate terms with "-no-tags" in type node of terms
                const termsWithFilter: Term[] = terms.filter((term: Term) => {
                    return !term.type.includes("-no-tags");
                });

                this.setState({
                    loading: false,
                    reservationDetails,
                    primaryGuest,
                    terms: termsWithFilter,
                    preferenceOptions: preferences,
                    selectedPreferences,
                })
            });
        }
    }

    updateStayPreferences = (selectedPreferences: SelectedPreferences) => {
        sessionStorage.write(ReservationService.SELECTED_PREFERENCES, JSON.stringify(selectedPreferences));
        this.setState({selectedPreferences});
    }

     /**
     * used to navigate to search availabilty
     */
    goToSelectAvailability() {
        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            this.props.setScreenType(ScreenType.SEARCH_RESORTS);
        }
        else {
            // VCAP (production)
            window.location.href = '/start_booking.do';
        }
    }

  /**
   * cancel was confirmed, release holds and go to search
   */
  cancelReservation = () => {
    const { localize } = this.context;
    this.reservationService.deleteHeldResorts(this.props.resId)
        .then(() => {
          //this.setState({showCancelModal: !this.state.showCancelModal});
          //sessionStorage.remove(ReservationService.OPS_FORM_SESSION_KEY);
          sessionStorage.remove(ReservationService.APPLIED_POINTS);
          this.goToSelectAvailability();
        })
        .catch((error: any) => {
          //const errorMessage = error.message ? `${error.message}` : "Unspecified error";
          const errorMessage = error.message ? `${error.message}` : localize('static.content.pwas-search-fatal-error-message');
          console.log(`Releasing hold on reservation ${this.props.resId} failed; ${errorMessage}`);
          console.error(`Error: ${JSON.stringify(error)}`);
          //NOTE: seems like it makes sense to navigate back to search availability screen
          //even if we failed to release a hold on reservation. The res hold might be already expired as an example
          //sessionStorage.remove(ReservationService.OPS_FORM_SESSION_KEY);
          this.goToSelectAvailability();
        });
    }

    /**
     * fired when the 'Cancel' button is clicked
     */
    toggleCancelModal = () => {
        this.setState({showCancelModal: !this.state.showCancelModal});
        /**
         * PWAS Analytics on Review Page 
         * Cancel Button
         */
        logAnalyticData({ event: 'Review and Cancel', siteSection: 'Points', pageName:'Review Page', website:'' }, {
            ownerActivity: 'Points Reservation',
            step:'Step 5: Points Booking – Step 5 – Review – Cancel',
            errorMessagfe:"",
            notificationType: "",
            customerID:"",
            searchCheckInDate: "",    
            alternativeSearchResorts:  this.state.isAlternateSearchAvailable ?"yes":"no"
          })
          trackAnalyticData('Points Booking – Step 5 – Review – Cancel');
    }

    //we saved Select Availability state into the browser's history before forwarding to AYP page
    //so, here we just simulate back button click on Browser
    goBackToSelectAvailabilityElementOnSearchScreen = () => {
        sessionStorage.remove(ReservationService.SELECTED_PREFERENCES);
        sessionStorage.remove(ReservationService.APPLIED_POINTS);

        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            this.props.setScreenType(ScreenType.SEARCH_RESORTS);
        }
        else {
            // VCAP (production)
            window.history.back();
        }

        /**
         * PWAS Analytics on Edit Search 
         * Review Page
         */
        logAnalyticData({ event: 'Search Resorts', siteSection: 'Points', pageName:'Review Page', website:'' }, {
            ownerActivity: 'Points Reservation',
            step:'Step 5 –Review and Book',
            errorMessagfe:"",
            notificationType: "",
            customerID:"",
            searchCheckInDate: "", 
            alternativeSearchResorts:  this.state.isAlternateSearchAvailable ?"yes":"no"   
          })  
        trackAnalyticData('Points Booking – Step 5 – Review – Edit Search');
    };

    handleAdditionalGuestsChange = (additionalGuests: GuestDetail[]) => {
        // update guests in state, then check for validation on page
        this.setState({ additionalGuests }, () => {
            // if the additional guest page error is present, check if we can remove it
            const pageErrors = {...this.state.pageErrors};
            if (pageErrors.additionalGuests.isErrored) {
                if (this.validateAdditionalGuests()) {
                    pageErrors.additionalGuests.isErrored = false;
                    this.setState({ pageErrors });
                }
            }
        });
    }

    handleEmailsChange = (emails: GuestEmail[]) => {

        // validate all emails and remove errors if errors are present
        // we only add errors on blur
        const pageErrors = {...this.state.pageErrors};
        let oneEmailHasError = false;
        emails.map(email => {
            if (this.validateEmail(email.email)) {
                email.isError = false;
            } else {
                oneEmailHasError = true;
            }
        })

        if (!oneEmailHasError && pageErrors.emails.isErrored) {
            pageErrors.emails.isErrored = false;
        }

        this.setState({ emails, pageErrors }, () => {
            // validate TnC - they might be errored because additional emails are added and that term
            // isn't checked --- and they might have just removed the only email
            const pageErrors = {...this.state.pageErrors};
            if (this.state.pageErrors.terms.isErrored) {
                if (this.validateTNCs()) {
                    pageErrors.terms.isErrored = false;
                    this.setState({ pageErrors });
                }
            }
        });
    }

    onEmailBlur = (emailIndex: number, e: React.FocusEvent<HTMLInputElement>, email: GuestEmail) => {
        const validEmail = this.validateEmail(email.email);

        if (!validEmail) {
            // set error on the email that was just blurred
            const emails = [...this.state.emails];
            emails[emailIndex].isError = true;
            this.setState({emails});
        }
    };

    /**
     * ensure additional guests have a first and last name or both are blank
     */
    validateAdditionalGuests = (): boolean => {
        const additionalGuests = [...this.state.additionalGuests];

        let oneErrorExists = false;
        additionalGuests.map(guest => {
            const updatedGuest = {...guest};
            const bothAreEmpty = guest.firstName.trim().length === 0 && guest.lastName.trim().length === 0;
            const validFirstName = guest.firstName.trim().length > 0;
            const validLastName = guest.lastName.trim().length > 0;

            updatedGuest.errors.firstName = !validFirstName && validLastName;
            updatedGuest.errors.lastName = !validLastName && validFirstName;

            if (!(bothAreEmpty || (validFirstName && validLastName))) {
                oneErrorExists = true;
            }

            guest = updatedGuest;
        });

        this.setState({ additionalGuests });

        return !oneErrorExists;
    }

    /**
     * ensure primary guest details that are required are present
     */
    validatePrimaryGuest = (): boolean => {
        const primaryGuest = this.state.primaryGuest;

        const { firstName, lastName, addressLine1, country, state, email } = primaryGuest;

        return (
            (firstName !== undefined && firstName.length > 0) &&
            (lastName !== undefined && lastName.length > 0) &&
            (addressLine1 !== undefined && addressLine1.length > 0) &&
            country !== null && country !== undefined &&
            state !== null && state !== undefined &&
            (email !== undefined && email.length > 0)
        );
    }

    /**
     * validate the additional emails added
     */
    validateEmails = (): boolean => {
        return this.state.emails.every(guestEmail => {
            return this.validateEmail(guestEmail.email);
        });
    }

    /**
     * validate the terms are checked
     */
    validateTNCs = (): boolean => {
        return !this.state.terms.filter(term => this.termFilter(term)).some(term => {
            return term.acknowledgementNeeded === 'true' && !term.checked
        });
    }

    /**
     * validate the additional emails added
     */
    validateEmail = (email: string): boolean => {
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return email.trim() === '' || re.test(email);
    }

    handleSubmit = () => {
        const isValid = this.validatePage();
        const { localize } = this.context;
       
        if (!isValid) {
            return;
        }

        if(isValid) {
            /** Prepare payload for backend */
                // TODO: filter out emails that are isError = true
                // TODO: filter out additional guests that are isError = true
                // TODO: clear reservation session data and route to summary confirmation
    
                const selectedPreferenceCodes: string[] = [];
    
                Object.values(this.state.selectedPreferences.roomRequests).forEach(selection => {
                    if (Array.isArray(selection)) {
                        return selection.forEach(multiSelection => selectedPreferenceCodes.push(multiSelection));
                    }
    
                    if ((selection as string) !== '-1') {
                        selectedPreferenceCodes.push(selection as string);
                    }
                });
    
                console.log({selectedPreferenceCodes})
    
                const resortImage = this.state.reservationDetails.resortImage ? this.state.reservationDetails.resortImage : "";
    
                const usageRequiredByDay = JSON.parse(sessionStorage.read(ReservationService.USAGE_REQUIRED_BY_DAY));
    
                this.setState({ submissionPending: true });
                const primaryGuestInfo = this.state.primaryGuestInfo;
                if (!primaryGuestInfo.postalCode) {
                    primaryGuestInfo.postalCode = ''
                }

                // Get language from cookie and set webSiteLang accordingly
                let webSiteLang = 'lang-english-us';
                const langCookieRow = document.cookie
                  .split('; ')
                  .find(row => row.startsWith('langPref='));
                const langCookie = langCookieRow ? langCookieRow.split('=')[1] : undefined;

                if (langCookie === 'es') {
                  webSiteLang = 'lang-spanish-es';
                } else if (langCookie === 'ja') {
                  webSiteLang = 'lang-japanese-ja';
                } else if (langCookie === 'zh') {
                  webSiteLang = 'lang-chinese-zh';
                } else if (langCookie === 'en' || langCookie === 'oljs-default' || !langCookie) {
                  webSiteLang = 'lang-english-us';
                }

                const params: BookResortParams = {
                    summary : {
                        primaryGuest: { ...this.state.primaryGuestInfo, firstName: this.state.primaryGuest.firstName, lastName: this.state.primaryGuest.lastName },
                        terms: this.state.terms,
                        reservationDetails: {
                            ...this.state.reservationDetails,
                            resortImage,
                        },
                        preferences: this.state.preferenceOptions,
                        extras : {
                          webSiteLang : webSiteLang,
                          webSiteBaseUrl : window.location.origin,
                          obl : sessionStorage.read(ReservationService.BENEFIT_LEVEL)
                        }
                    },
                    pointsUsage: (this.props.appliedPointContracts as ContractUsage[]).filter(x => x.appliedPoints > 0).map(contract => ({
                        contractId: contract.contractId,
                        pointsApplied: contract.appliedPoints,
                        usageYearId: contract.usageId,
                        days: '0',
                        usageYear: contract.usageYear,
                        usageType: contract.usageType,
                        transactionType: contract.borrowChecked ? 'Borrow' : ''
                    })),
                    usageRequiredByDay,
                    reservedInventoryId : this.props.resId,
                    primaryGuest : this.state.primaryGuestInfo,
                    additionalGuests: this.state.additionalGuests,
                    additionalEmails: this.state.emails.map(email => email.email),
                    selectedStayPreferences: {
                        codes : selectedPreferenceCodes,
                        note: this.state.selectedPreferences.additionalRequests
                    }
                };
                
    
                this.reservationService.bookReservation(params, this.props.resId)
                .then(result => {
                    // 202 status indicates no confirmation #
                    if (result.status === 202) {
                        result.data.twoOhTwoBookingError = true;
                    }
                    sessionStorage.write(ReservationService.BOOKED_RESERVATION, JSON.stringify(result.data));

                    /**
                    * Remove default search cache before going to confirmation page
                    */
                    const opsForm = sessionStorage.read(ReservationService.OPS_FORM_SESSION_KEY);
                
                    if(opsForm) {
                        const formObject = JSON.parse(opsForm);
                        delete formObject.advancedSearch;
                        sessionStorage.remove(md5(JSON.stringify(formObject)));
                    }
    
                    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
                        sessionStorage.write("SCREEN_TYPE", ScreenType.SUMMARY_REVIEW);
                        this.props.setScreenType(ScreenType.SUMMARY_REVIEW)
                    }
                    else {
                        window.scrollTo(0, 0);
                        window.location.reload(false);
                    }

                    /**
                     * PWAS Analytics on Review Page
                     * On submit of Book Reservation Button
                     */
                    logAnalyticData({ event: 'Search Resorts', siteSection: 'Points', pageName:'Review Page', website:'' }, {
                        ownerActivity: 'Points Reservaion',
                        step:'Step 5: Points Booking – Step 5 – Review – Book Reservation',
                        errorMessagfe:"",
                        notificationType: "",
                        typeOfSearch:"",
                        pointsChanged:"",
                        resortID:"",  
                        alternativeSearchResorts:  this.state.isAlternateSearchAvailable ?"yes":"no"
                      })
                    trackAnalyticData('points:step5');
                 
                }).catch(error => {
                    console.log({error})
                    this.setState({ submissionPending: false, showErrorModal : true, errorMessage: localize('static.content.sr-summary-review-error') });
                });;
        }
    }

    handleWaitlistCancel = () => {
        const { localize } = this.context;
        this.waitlistService.deleteWaitlist(this.props.waitListId || 0)
        .then(res => {
            sessionStorage.remove("WAITLIST_RESPONSE");
            sessionStorage.write(ReservationService.BOOKED_RESERVATION, JSON.stringify(res));
             if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
                sessionStorage.write("SCREEN_TYPE", ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW);
                this.props.setScreenType(ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW);
            } else {
                window.scrollTo(0, 0);
                window.location.reload(false);
            }
        }).catch(err => {
            // sessionStorage.remove("WAITLIST_RESPONSE");
            console.log({err})
            this.setState({ showErrorModal : true, errorMessage: localize('static.content.sr-summary-review-error') });
        });
    }

    toggleErrorModal = () =>  {
        this.setState({showErrorModal: !this.state.showErrorModal});
    }

    handleUsageDetailsEditClick = () => {
        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            this.props.setScreenType(ScreenType.APPLY_POINTS);
        }
        else {
            // VCAP (production)
            window.location.href = `/applyPoints.jsp?resId=${this.props.resId}`;
        }

        logAnalyticData({ event: 'Search Resorts', siteSection: 'Points', pageName:'Review Page', website:'' }, {
            ownerActivity: 'Points Reservaion',
            step:'Step 5: Points Booking – Step 5 – Review – Edit Points Usage',
            errorMessagfe:"",
            notificationType: "",
            typeOfSearch:"",
            pointsChanged:"",
            resortID:"", 
            alternativeSearchResorts:  this.state.isAlternateSearchAvailable ?"yes":"no" 
          })
        trackAnalyticData('points:step5');
    }

    /**
     * use this function to run all validation functions
     * and check if booking can be submitted
     *
     * returns true if the page is valid
     */
    validatePage = (): boolean => {
        const pageErrors = {...this.state.pageErrors};
        let pageHasError = false;

        // validate additional guests
        if (!this.validateAdditionalGuests()) {
            pageErrors.additionalGuests.isErrored = true;
            pageHasError = true;
        }

        // validate emails
        if (!this.validateEmails()) {
            pageErrors.emails.isErrored = true;
            pageHasError = true;
        }

        // validate TnC
        if (!this.validateTNCs()) {
            pageErrors.terms.isErrored = true;
            pageHasError = true;
        }

        // validate primary guest edit status
        if (this.state.isEditInProgress) {
            pageErrors.primaryGuest.isErrored = true;
            pageHasError = true;
        }

        // validate primary guest
        // if (!this.validatePrimaryGuest()) {
        //     pageErrors.primaryGuest.isErrored = true;
        //     pageHasError = true;
        // }

        this.setState({ pageErrors })

        return !pageHasError;
    }

    handleClickOnTnC = (type: string) => {
        const newTerms = [...this.state.terms];
        const term = newTerms.find(term => term.type === type);
        if (term) {
            term.checked = !term.checked;
        }
        // validate TnC - if error message is present, remove is fixed
        const pageErrors = {...this.state.pageErrors}
        if (this.state.pageErrors.terms.isErrored) {
            if (this.validateTNCs()) {
                pageErrors.terms.isErrored = false;
            }
        }
    
        this.setState({ terms: newTerms, pageErrors });
        this.setState({ allTnCChecked: newTerms.every(term => term.checked || !this.termFilter(term)) });
    }

    termFilter = (term: Term) => {
        // don't show email term if no emails are entered that are valid
        if (
            this.state.emails.length === 0 ||
            !this.state.emails.some(email => {
                return this.validateEmail(email.email) && email.email.length > 0
            })
        ) {
            return term.type !== 'terms-additional-emails'
        }

        return true;
    };

    handleUpdateGuestProfile = (updatedGuest: PrimaryGuest) => {
        this.setState({ primaryGuestInfo: updatedGuest });
    }

    handleUpdateEditStatus = (status: boolean) => {
        this.setState({ isEditInProgress: status });

    }

    handleSetExpirationLeadTime = (expirationLeadTime: number) => {
        this.setState({expirationLeadTime})
    }

    getSubmitButtonText = () => {
        const { localize } = this.context;
        if (this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW) {
            return "Cancel Waitlist";            
        } else {
            return localize("Book Reservation");
        }
    }

    render() {
        const { localize } = this.context;
        const { numOfGuests } = this.state.reservationDetails;

        return (
            <div className='summary-review'>
                <MvConfirmationModal
                    header = ""
                    description = {localize("static.content.ayp-cancel-transaction")}
                    message = {localize("static.content.ayp-cancel-transaction-warning")}
                    abortLabel = {localize("static.content.ayp-do-not-cancel-transaction")}
                    confirmLabel = {localize("static.content.ayp-do-cancel-transaction")}
                    openModal={this.state.showCancelModal}
                    toggleModal={this.toggleCancelModal}
                    confirm={this.cancelReservation}
                    abort={this.toggleCancelModal}
                />
                <MvConfirmationModal
                    header = "Error"//{localize("static.content.reservations-error-header")}
                    description = {this.state.errorMessage}
                    message = ""
                    abortLabel = ""
                    confirmLabel = {localize("OK")} //{localize("static.content.reservations-confirm-error")}
                    openModal={this.state.showErrorModal}
                    toggleModal={this.toggleErrorModal}
                    confirm={this.toggleErrorModal}
                    abort={() => {}}
                />
                <MvLoader show={this.state.loading} >
                    <h1 className="page-header">
                        {" "}
                        {!this.props.screenType && localize("static.content.sr-summary-header")}
                        {this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW && "Waitlist: Cancel Summary"}
                    </h1>
                    {this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW && <span><b>Waitlist #</b>: {this.props.waitListId}</span>}

                  {this.props.screenType ? 
                    (  
                        <BookingInfoExists
                            waitlistReservationID={0} //TODO: Need to fix
                            waitlistRooms={this.state.waitlistRooms}
                            // pointAmountMin={0} //TODO: Need to fix
                            reservationDetails={this.state.waitlistReservationDetails}
                            //pointsRequired={String(this.state.waitlistReservationDetails.pointsRequired)}
                            onEditSegmentClick={this.goBackToSelectAvailabilityElementOnSearchScreen}
                            readOnly={false}
                            visitResortNewTab={false}
                            hideHeader={true}
                            noOfSegmentsInWaitlist={0}
                        />
                    )  :
                        <BookingInfo
                            reservationDetails={this.state.reservationDetails}
                            pointsRequired={this.state.reservationDetails.pointsRequired}
                            onEditSearchClick={this.goBackToSelectAvailabilityElementOnSearchScreen}
                            readOnly={false}
                            setScreenType={this.props.setScreenType}
                        />
                  }

                    <div className='border-container'>
                        {this.props.screenType &&
                            <WaitlistCriteria
                                checkIn={this.state.waitlistReservationDetails.checkInRangeStart}
                                expirationLeadTime={this.state.expirationLeadTime}
                                setExpirationLeadTime={this.handleSetExpirationLeadTime}
                                readOnly={this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW}
                            />
                        }
                        <StayPreferences
                            selectedPreferences={this.state.selectedPreferences}
                            preferenceOptions={this.state.preferenceOptions}
                            updateStayPreferences={this.updateStayPreferences}
                            optionsLoading={this.state.loading}
                            readOnly={this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW}
                        />
                        <GuestProfile
                            guest={this.state.primaryGuest}
                            readOnly={false}
                            updateGuestProfile={this.handleUpdateGuestProfile}
                            updateEditStatus={this.handleUpdateEditStatus}
                        />
                        <AdditionalGuestProfile
                            maximumGuestCount={numOfGuests - 1}
                            additionalGuests={this.state.additionalGuests}
                            emails={this.state.emails}
                            onAdditionalGuestsChange={this.handleAdditionalGuestsChange}
                            onEmailsChange={this.handleEmailsChange}
                            onEmailBlur={this.onEmailBlur}
                            onAdditionalGuestInputBlur={this.validateAdditionalGuests}
                            readonly={this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW}
                        />
                        <UsageDetails
                            contracts={(this.props.appliedPointContracts != null ? this.props.appliedPointContracts.filter(c => c.appliedPoints > 0) : [])} //changing !== to != catches both null and undefined
                            contractToolTips={this.props.contractToolTips}
                            onContractsSort={this.props.handleContractsSort}
                            onEditClick={this.handleUsageDetailsEditClick}
                            readOnly={this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW}
                            tablesExpandable={true}
                            tablesInitOpen={true}
                            screenType={this.props.screenType}
                            apiTimeout = {this.props.apiTimeout}
                        />
                        <div className='summaryReviewTnC'>
                            <MvTermsConditions
                                heading={this.props.screenType?"Terms & Conditions":localize("static.content.sr-tnc-heading")}
                                subHeading={this.props.screenType?"Required Terms & Conditions must be Acknowledged": localize("static.content.sr-tnc-sub-heading")}
                                instructions={this.state.terms.filter(term => this.termFilter(term))}
                                onChange={this.handleClickOnTnC}
                                submissionFailed={this.state.pageErrors.terms.isErrored}
                            />
                        </div>
                    </div>
                    <div className='footer-section'>
                        <div className='page-errors'>
                            {Object.keys(this.state.pageErrors).map(key => {
                                const pageErrorObj = this.state.pageErrors[(key as PageErrorType)];
                                if (pageErrorObj.isErrored) {
                                    return (
                                        <div className='mv-input-err-msg'>{pageErrorObj.message}</div>
                                    );
                                }
                            })}
                        </div>
                        <div className='action-btns'>
                            <MvLink
                                label={localize("static.content.cancel")}
                                onClick={() => this.toggleCancelModal()}
                            />
                            <div style={ !this.state.allTnCChecked ? { opacity: '0.5' } : {}}>
                            <MvPrimaryBtn
                                isDisabled={this.state.submissionPending}
                                submissionInProgress={this.state.submissionPending}
                                text={this.getSubmitButtonText()}
                                onClick={this.props.screenType === ScreenType.WAITLIST_CANCEL_SUMMARY_REVIEW ? this.handleWaitlistCancel : this.handleSubmit}
                            />
                            </div>
                        </div>
                    </div>
                </MvLoader>
            </div>
        );
    }
}


Review.contextType = LocalizationContext;

export default Review;